import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  @font-face {
      font-family: 'Larken';
      src: url('https://static.urban.co/fonts/Larken/webFonts/LarkenLight/font.woff') format('woff');
      font-weight: 300;
      font-style: normal;
      font-display: swap;
  }

  @font-face {
      font-family: 'Larken';
      src: url('https://static.urban.co/fonts/Larken/webFonts/LarkenLightItalic/font.woff') format('woff');
      font-weight: 300;
      font-style: italic;
      font-display: swap;
  }

  @font-face {
      font-family: 'Larken';
      src: url('https://static.urban.co/fonts/Larken/webFonts/LarkenThin/font.woff') format('woff');
      font-weight: 100;
      font-style: normal;
      font-display: swap;
  }

  *, *::before, *::after {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  html {
    font-size: 62.5%;
    scroll-behavior: smooth;
  }
  body {
    margin: 0;
    padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
  }
  h1, h2, h3, h4, h5, h6, p, a {
    margin: 0;
  }
  input, textarea, button {
    font-family: inherit;
  }
  input[type='tel'] {
    background-color: white !important;
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* stylelint-disable property-no-vendor-prefix */
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
  a {
    text-decoration: none;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  /* ServiceOS transaction banner */
  #transaction-banner-section {
    display: flex;
    justify-content: center;
    z-index: 10;
    position: fixed;
    top: 130px;
    transition: all 0.2s ease-in-out;
    width: 100%;
}

.transaction-banner-section.show {
    overflow: hidden;
    padding: 24px;
}
.transaction-banner-inner-wrap {
  max-width: 770px;
  width: 100%;
}

.transaction-banner {
    position: relative;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 0px 12px 0px #2B2B2B26;
    padding: 24px;
    color: #4f657e;
}

.transaction-banner .banner-elements {
  display: flex;
  justify-content: space-between;
}

.banner-text-container {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.banner-text-title {
  font-size: 20px;
  font-family: 'Larken', sans-serif;
  font-weight: 300;
  color: black;
}

.banner-text-description {
    font-size: 16px;
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    color: black;
}

.banner-actions-container { 
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.transaction-banner .primary-btn.desktop-btn {
    display: flex;
    align-items: center;
    padding-inline: 28px;
    background-color: #FAC600;
    border-radius: 20px;
    height: 32px;
    font-size: 14px;
    font-family: 'Roboto', sans-serif;
    color: black;
    border: none;
    cursor: pointer;
}

.close-transaction-banner-desktop {
    cursor: pointer;
    margin-top:2px;
    
}

.close-transaction-banner-desktop:before {
    content: url("/assets/images/x-close.svg");
}

@media (max-width: 800px) {

  .close-transaction-banner-desktop {
    display: none;
  }
  .close-transaction-banner-desktop:before {
    content: none;
}

  #transaction-banner-section {
    padding-inline: 12px;
  }

  .transaction-banner {
    display: flex;
    padding: 18px;
  }

    .transaction-banner .banner-elements {
      width: 100%;
      flex-direction: column;
      gap: 18px;
}

.banner-text-container {
  gap: 3px;
}

.banner-text-title {
    font-size: 16px;
    font-weight: 300;
}

.banner-text-description {
    font-size: 14px;
    font-weight: 300;
}

.close-transaction-banner-mobile {
  cursor: pointer;
  display: block;
  padding-left: 12px;
  margin-top: 0px;
}

.close-transaction-banner-mobile:before {
    content: url("/assets/images/x-close.svg");
}

}
@media (max-width: 575px) {
    #transaction-banner-section {
    top: 160px;
  }
}

@media (max-width: 400px) {
  .transaction-banner .primary-btn.desktop-btn{
    justify-content: center;
    width: 100%;
}
}
`;

export default GlobalStyle;
